import { Stack, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import { type Goal as GoalModel } from '@feathr/blackbox';
import { Well } from '@feathr/components';
import { ConversionModelRadios } from '@feathr/extender/components';

import ConversionValueEntry from './ConversionValueEntry';
import GoalHeading from './GoalHeading';
import GoalTypeSelect from './GoalTypeSelect';

interface IProps {
  children: ReactNode;
  goal: GoalModel;
}

function GoalLayout({ children, goal }: Readonly<IProps>): JSX.Element {
  const {
    spacing: { '4': gap },
  } = useMantineTheme();

  return (
    <Well borderless={true}>
      <Stack gap={gap} w={'100%'}>
        <GoalHeading goal={goal} />
        <GoalTypeSelect goal={goal} />
        {children}
        <ConversionValueEntry goal={goal} />
        <ConversionModelRadios goal={goal} />
      </Stack>
    </Well>
  );
}

export default observer(GoalLayout);
